<a
	class="horizontal-item"
	[class.active]="active"
	[class.tone-stocks]="tone === 'stocks'"
	[class.tone-magenta]="tone === 'magenta'"
	[class.tone-green]="tone === 'green'"
	[class.not-implemented]="item.implemented !== true"
	[class.disabled]="item.disabled === true"
	[href]="item.href"
	[attr.aria-disabled]="item.disabled === true"
	(click)="onClick($event)"
>
	{{ item.label }}
</a>
